import * as THREE from 'three';

export default function decompose(matrix4) {
  const translation = new THREE.Vector3();
  const rotQuat = new THREE.Quaternion();
  const scale = new THREE.Vector3();
  matrix4.decompose(translation, rotQuat, scale);
  const rotation = new THREE.Vector3().copy(new THREE.Euler().setFromQuaternion(rotQuat, 'ZYX'));
  rotation.multiplyScalar(180 / Math.PI); // convert to degrees
  return { translation, rotation };
};




// WEBPACK FOOTER //
// ./src/translators/utils/decompose.js